import { createSlice } from '@reduxjs/toolkit';
import { sessionName } from '../../../utils';

const initialState = {
  isLoading: true,
  sessionValidated: false,
  full_name: '',
  photo_user: '',
  main_profile: '',
  notifications: [],
  permissions: [],
  username: '',
  super_admin_user: 0,
  key_customer: null,
  type: null,
  isCustomer: false,
  events: [],
  banners: [],
  categories: [],
}

export const sessionSlice = createSlice({
  name: 'session',
  initialState: initialState,
  reducers: {
    setJwt: (state, action) => {
      localStorage.setItem(sessionName(), action.payload.jwt);
    },
    setSession: (state, action) => {
      state.full_name = action.payload.full_name
      state.photo_user = action.payload.photo_user
      state.main_profile = action.payload.main_profile
      state.notifications = action.payload.notifications
      state.permissions = action.payload.permissions
      state.username = action.payload.username
      state.super_admin_user = action.payload.super_admin_user
      state.sessionValidated = true;
      state.isLoading = false;
      state.key_customer = action.payload.key_customer
      state.type = action.payload.type
      state.isCustomer = action.payload.type === 'customer'
    },
    setPageData: (state, action) => {
      state.events = action.payload.events
      state.banners = action.payload.banners
      state.categories = action.payload.categories
    },
    setStartLoading: (state) => {
      state.isLoading = true;
    },
    sessionClear: (state) => {
      localStorage.removeItem(sessionName());
      state.isLoading = false;
      state.sessionValidated = false;
      state.full_name = '';
      state.photo_user = '';
      state.main_profile = '';
      state.notifications = [];
      state.permissions = [];
      state.username = '';
      state.super_admin_user = 0;
      state.key_customer = null;
      state.type = null;
      state.isCustomer = false;
    },
  }
});

export const { setSession, setStartLoading, setJwt, sessionClear, setPageData } = sessionSlice.actions;